import React from "react";
import { ShopProductFrame } from "./ShopProductDecoration";

const fallbackServer = {
  server_name: "나만의 커뮤니티",
  description: "함께 이야기하고 즐길 사람들을 기다리고 있어요.",
};

export default function MarketplacePreviewCard({
  product,
  server,
  compact = false,
  className = "",
}) {
  const preview = { ...fallbackServer, ...(server || {}) };
  const description = preview.description || "서버 설명이 없습니다.";

  return (
    <ShopProductFrame
      product={product}
      className={`market-preview-card w-full bg-[#1b1c20] border border-[#3a3c43] ${className}`}
      style={{ aspectRatio: compact ? "4 / 4.25" : "4 / 5" }}
    >
      <div className="absolute inset-x-0 top-0 h-[39%] bg-[#292a2f]" />
      {!compact && (
        <div className="absolute right-[5%] top-[5%] z-30 rounded-md bg-[#3b4658] px-3 py-2 text-[11px] font-bold text-white shadow">
          서버 참가
        </div>
      )}
      <div className="absolute left-[7%] top-[31%] z-30 flex h-[18%] aspect-square items-center justify-center overflow-hidden rounded-full border-[4px] border-[#1b1c20] bg-[#5865F2] text-lg font-bold text-white">
        {preview.iconUrl ? (
          <img src={preview.iconUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          String(preview.server_name || "D").slice(0, 1)
        )}
      </div>
      <div className="absolute inset-x-[7%] bottom-[7%] top-[52%] z-30 flex min-h-0 flex-col">
        <strong className="truncate text-[clamp(13px,3.7cqw,19px)] text-white">
          {preview.server_name}
        </strong>
        <div className="mt-[5%] min-h-0 flex-1 overflow-hidden rounded-md border border-[#35363c] bg-[#242529] p-[6%] text-[clamp(9px,2.7cqw,13px)] leading-relaxed text-[#c7c9d1]">
          {description}
        </div>
      </div>
    </ShopProductFrame>
  );
}
